<template>
  <div
    class="check-wrap"
    :class="{ 'checked': value, 'force-mobile':forceMobile}"
    :style="{ 'font-size': size }"
    @click="$emit('change', !value)"
  >
    <div
      v-if="!isMobile && !forceMobile"
      class="check-box"
      :style="{
        width: size,
        height: size
      }"
    >
      <fps-icon v-show="value" type="check" color="#fff" />
    </div>
    <slot></slot>
  </div>
</template>

<script>
export default {
  model: {
    prop: 'value',
    event: 'change'
  },
  data() {
    return {
      isMobile: window.innerWidth < 600,
    }
  },
  props: {
    forceMobile: {
      default: false,
    },
    value: {
      default: false,
    },
    size: {
      type: String,
      default: '14px',
    }
  }
}
</script>

<style lang="scss" scoped>
  .check-wrap {
    @include flex;
    color: $color-gray-2;
    cursor: pointer;
    .check-box {
      @include flex;
      background-color: #fff;
      border: 1px solid rgba(140, 148, 170, 0.5);
      border-radius: 1px;
      margin-right: 4px;
      .fps-icon {
        transform: scale(0.8);
      }
    }
    &:hover {
      color: $color-gray-1;
    }
    &.checked {
      color: $color-link;
      .check-box {
        background-color: $color-link;
        border: 1px solid $color-link;
      }
    }
  }
  .check-wrap.force-mobile{
      background-color: #F1F3F6;
      padding: 6px 10px;
      width: 88px;
      height: 44px;
      color: $color-gray-2;
      font-size: 14px;
      line-height: 20px;
      border: 1px solid $color-split;
      border-radius: 4px;
      &:hover {
        color: $color-gray-2;
      }
      &.checked {
        background-color: $color-gray-2;
        color: #fff;
      }
  }

  @media screen and (max-width: 599px) {
    .check-wrap {
      background-color: #F1F3F6;
      padding: 6px 10px;
      color: $color-gray-2;
      font-size: 14px;
      line-height: 20px;
      border: 1px solid $color-split;
      border-radius: 4px;
      &:hover {
        color: $color-gray-2;
      }
      &.checked {
        background-color: $color-gray-2;
        color: #fff;
      }
    }
  }
</style>
